import { apiClient } from './client';
import type {
  DressCodeTemplateGroup,
  DressCodeTemplate,
} from '@/types/dressCode.types';

export class DressCodeTemplateService {

  /**
   * Get ranked template suggestions for a celebration based on its confirmed tags.
   */
  async getSuggestions(celebrationId: number): Promise<DressCodeTemplateGroup[]> {
    const response = await apiClient.get(`/dress-code-templates/suggestions/${celebrationId}`);
    return response.data.data || [];
  }

  /**
   * Get all cells for a specific template group by name.
   */
  async getByName(name: string, celebrationId: number): Promise<DressCodeTemplate[]> {
    const encoded = encodeURIComponent(name);
    const response = await apiClient.get(
      `/dress-code-templates/by-name/${encoded}?celebrationId=${celebrationId}`
    );
    return response.data.data || [];
  }

  /**
   * List all templates, optionally filtered by tag IDs.
   */
  async getAll(tagIds?: number[]): Promise<DressCodeTemplate[]> {
    const params = tagIds && tagIds.length > 0 ? `?tagIds=${tagIds.join(',')}` : '';
    const response = await apiClient.get(`/dress-code-templates${params}`);
    return response.data.data || [];
  }
}

export const dressCodeTemplateService = new DressCodeTemplateService();
